var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #4f7fff;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.8,8.3l16.8-.6,15.4-.6,15-.7c2.2,0,4.5-.3,6.8-.3l10-.2h5.5l10.3.2,15.4.6,31.5,1.3,15.5.8,15.4.7c9.7.4,19.4.7,29,1.3l8,.5,8.9.7,7.7.7,3.2.3,3.7.5,5.2.6,6.6,1.2h.6c1,.1,2-.5,2.3-1.5.2-.6.1-1.3-.2-1.9-.2-.4-.8-1-1.3-1.1l-4.2-.8-4.2-.7c-4.6-.6-9.1-1.1-13.7-1.6.8-.5,1.2-1.5,1-2.4-.2-.6-.6-1.2-1-1.5l-1.1-.5c-.9-.2-1.7-.3-2.6-.4l-2-.3-3.8-.2-7.5-.4-15.5-.5-15.4-.3-8.1-.2h-24.4l-15.8-.2c-9.7-.1-19.6-.2-29.4-.1h-14.6c-5.2,0-10.4,0-15.6.2h-10.3c0,.1-5.9.2-5.9.2l-9.4.4-6.2.3c-7.4.5-14.7,1-22,1.7-.5,0-.8.3-1.1.6-.5.4-.8,1-.8,1.6,0,1.3,1,2.5,2.3,2.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine2);
export default __webpack_public_path__ + "static/media/line2.9050dccdef37f354050889ca7434fde7.svg";
export { ForwardRef as ReactComponent };